import { Component, Emit, Ref, Vue } from 'vue-property-decorator'
import {
    initialLoginLayoutRecoveryState,
    LoginLayoutRecoveryState
} from '@/views/auth/components/login/login-layout-recovery/login-layout-recovery.model'
import VtInput from '@/components/common/VtInput.vue'
import { auth } from '@/api/auth'

@Component
export default class LoginLayoutRecovery extends Vue {
    @Ref() usernameInput!: typeof VtInput

    get hasError(): boolean {
        return !!this.state.error
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty && !this.state.busy
    }

    state: LoginLayoutRecoveryState
    constructor() {
        super()
        this.state = initialLoginLayoutRecoveryState()
    }

    mounted() {
        (this.usernameInput as any).focus()
    }

    @Emit('show-login')
    showLogin(): void {}

    @Emit('show-email-sent')
    private _showEmailSent(): void {}

    async recoverPassword(): Promise<void> {
        try {
            this.state.busy = true
            this.state.error = ''
            this.state.usernameInError = false

            await auth.recoveryPassword(this.state.username)
            this._showEmailSent()
        } catch (e) {
            this.$_showErrorModal()
            this.state.usernameInError = true
        } finally {
            this.state.busy = false
        }
    }
}
